import React, { useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import {
    FaChevronLeft,
    FaChevronRight,
    FaDollarSign,
    FaFireAlt,
    FaRegBookmark,
    FaRupeeSign,
} from "react-icons/fa";
import { Link } from "react-router-dom";

import { getAllProduct } from "../API/ProductAPI";
import Config from "../API/Config";

const Product1 = () => {
    const swiperRef = useRef(null);

    const [products, setProducts] = useState([]);
    const [displayedProducts, setDisplayedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const productsPerPage = 8;

    const StateId = Config.getStateId();
    const CountryId = Config.getCountryId();
    const currencySymbol = CountryId === 'IN' ? <FaRupeeSign /> : <FaDollarSign />;

    // Flatten API response to get all products with category
    const flattenProducts = useCallback((data) => {
        return data.flatMap(category =>
            category.Products.map(product => ({
                ...product,
                category: category.Name
            }))
        );
    }, []);

    // Fetch products
    useEffect(() => {
        const fetchProduct = async () => {
            setLoading(true);
            try {
                const res = await getAllProduct(CountryId, StateId);
                // const flattenedProducts = flattenProducts(res);
                const flattenedProducts = res;
                
                setProducts(flattenedProducts);
                setDisplayedProducts(flattenedProducts.slice(0, productsPerPage));
            } catch (error) {
                console.error("Error fetching products:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [StateId, CountryId, flattenProducts]);

    return (
        <section className="p-4 container mx-auto">
            <div className="flex items-center justify-between mb-4">
                <div>
                    <div className="loader-line"></div>
                    <h2 className="text-2xl font-bold text-gray-800 mt-3">Most Loved</h2>
                    <p className="text-gray-500">We Bring the Bread – Roti, Naan, Poori & More!</p>
                </div>
                <div className="relative flex items-center space-x-2">
                    <button
                        className="swiper-prev bg-white shadow-lg p-2 rounded-full hover:bg-gray-100 transition"
                        aria-label="Previous slide"
                    >
                        <FaChevronLeft className="text-gray-600 text-lg" />
                    </button>
                    <button
                        className="swiper-next bg-white shadow-lg p-2 rounded-full hover:bg-gray-100 transition"
                        aria-label="Next slide"
                    >
                        <FaChevronRight className="text-gray-600 text-lg" />
                    </button>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                {loading ? (
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                        {[...Array(5)].map((_, index) => (
                            <div key={index} className="bg-white shadow rounded-lg border border-[#e8e8e8] overflow-hidden animate-pulse">
                                <div className="w-full h-52 bg-gray-300 rounded-lg"></div>
                                <div className="p-3">
                                    <div className="h-4 bg-gray-300 rounded mb-2"></div>
                                    <div className="h-3 bg-gray-300 rounded mb-2 w-3/4"></div>
                                    <div className="h-3 bg-gray-300 rounded mb-2 w-1/2"></div>
                                    <div className="h-3 bg-gray-300 rounded mb-3 w-2/3"></div>
                                    <div className="h-8 bg-gray-300 rounded-3xl"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={10}
                        slidesPerView={5}
                        navigation={{
                            prevEl: ".swiper-prev",
                            nextEl: ".swiper-next",
                        }}
                        autoplay={{
                            delay: 3000, // 3 seconds between transitions
                            disableOnInteraction: true, // Pause on user interaction
                        }}
                        loop={true}
                        speed={500}
                        breakpoints={{
                            320: {
                                slidesPerView: 1.5,
                                spaceBetween: 10,
                                centeredSlides: false, // Center slides for partial visibility
                            },
                            480: {
                                slidesPerView: 1.5,
                                spaceBetween: 10,
                                centeredSlides: false, // Center slides for partial visibility
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 15,
                                centeredSlides: false,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                                centeredSlides: false,
                            },
                            1280: {
                                slidesPerView: 5,
                                spaceBetween: 20,
                                centeredSlides: false,
                            },
                        }}
                        ref={swiperRef}
                        className="mySwiper"
                    >
                        {displayedProducts.map((product, idx) => (
                            <SwiperSlide key={idx}>
                                <Link to={`/product-view/${product.Id}`}>
                                    <div className="bg-white shadow hover:shadow-[0px_8px_30px_rgba(0,0,0,0.15)] transform transition-transform duration-500 rounded-lg border border-[#e8e8e8] overflow-hidden">
                                        <div className="relative overflow-hidden">
                                            <img
                                                src={product.ThumbImage}
                                                alt={product.Name}
                                                className="w-full h-52 object-cover rounded-lg transform transition-transform duration-500 hover:scale-105"
                                            />
                                            {/* <div className="absolute -bottom-0 left-2 bg-green-800 text-white px-2 py-1 rounded">
                                                                            ⭐ {product.rating || '3.2'}
                                                                        </div> */}
                                        </div>
                                        <div className="p-3">
                                            <h3 className="font-semibold text-lg text-contentcolor">{product.Name}</h3>
                                            <p className="text-contentcolor mb-1 text-sm">{product.category}</p>
                                            <p className="text-contentcolor mb-1 flex items-center">
                                                <FaFireAlt className="mr-1" /> {product.Calories} Calories
                                            </p>
                                            <p className="text-contentcolor mb-3 flex items-center">

                                                <span className="mr-1 font-bold">
                                                    {currencySymbol}
                                                </span>
                                                <span className="font-semibold text-contentcolor">
                                                    {product.Variations[0]?.SalePrice || '15.00'}
                                                </span>
                                                {product.Variations[0]?.RegularPrice && (
                                                    <span className="line-through ml-1">
                                                        {product.Variations[0]?.RegularPrice}
                                                    </span>
                                                )}
                                                / {product.Variations[0]?.Name || 'piece'}
                                            </p>
                                            <button className="w-full bg-theme2 rounded-3xl text-white py-2 hover:bg-black transition">
                                                Add To Cart
                                            </button>
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </div> 
        </section>
    );
};

export default Product1;